export const a4d_castHelpers = {

    /**
     *
     * @param val
     * @param {string} type
     * @returns {*|number}
     */
    'cast' : function(val, type)
    {
        type = type.toLowerCase();

        switch (type) {
            case 'bool' :
            case 'boolean' :
                return a4d_castHelpers.BOOL(val);
            case 'float' :
                return a4d_castHelpers.FLOAT(val);
            case 'number' :
                return a4d_castHelpers.NUMBER(val);
            case 'int' :
            case 'integer' :
                return a4d_castHelpers.INT(val);
            case 'string' :
            case 'text' :
                return a4d_castHelpers.STRING(val);
        }
        return val;
    },

    'BOOL'      : function(val) {
        // Javascript does NOT have a working parse Bool function
        // bool("false") results in true ..... go figure
        switch( String(val).trim().toLowerCase() ){
            case "true":
            case "1":
            case "on":
            case "yes":
                return true;
            default:
                return false;
        }
    },
    'FLOAT'     : function(val) { return parseFloat(val) },
    'INT'       : function(val) { return parseInt(val) },
    'NUMBER'    : function(val) { return Number(val) },
    'STRING'    : function(val) { return String(val) }
}
